import {
  CREATE_NEW_USER,
  GET_ALL_USERS,
  GET_USER_DETAIL,
  UPDATE_USER_STATUS,
  UPDATE_USER_DETAIL,
  GET_USER_ROLES,
} from "./constants";

export function createUser(payload, onSuccess) {
  return {
    type: CREATE_NEW_USER,
    payload,
    onSuccess,
  };
}

export function getAllUsers() {
  return {
    type: GET_ALL_USERS,
  };
}

export function getUserDetail(id) {
  return {
    type: GET_USER_DETAIL,
    id: id,
  };
}

export function updateUserDetail(payload, onSuccess) {
  return {
    type: UPDATE_USER_DETAIL,
    payload,
    onSuccess,
  };
}
export function updateUserStatus(payload, onSuccess) {
  return {
    type: UPDATE_USER_STATUS,
    payload,
    onSuccess,
  };
}

export function getRoles(payload) {
  return {
    type: GET_USER_ROLES,
    payload,
  };
}
